import React from 'react';
import PropTypes from 'prop-types';

import './FlowButton.scss';

const FlowButton = ({
    text, onClick, disabled, type, className, icon
}) => {
    return (
        <button
            className={ `${ type === 'back' ? 'fl-back-btn' : 'fl-survey-new-button' } ${ className }` }
            onClick={ onClick }
            disabled={ disabled ? 'disabled' : undefined }>
            {icon && <span>{ icon }</span>}
            {text}
        </button>
    );
};

FlowButton.propTypes = {
    disabled: PropTypes.bool,
    type: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    className: PropTypes.string,
    text: PropTypes.string
};

FlowButton.defaultProps = {
    disabled: false,
    type: '',
    onClick: null,
    icon: null,
    className: '',
    text: ''
};

export default FlowButton;
